import { CheckCircle2 } from 'lucide-react'
import { cn } from '../../lib/utils'

/**
 * The list-view counterpart to the ApprovalCelebration banner: marks a job
 * whose quote is approved and ready to start work. Tapping the row/card
 * takes the mechanic to the job detail page where the Start Work banner
 * awaits.
 */
export function isJobReadyToStart(job: {
  stage?: string
  computed?: { approvalStatus?: string; needsReapproval?: boolean } | null
}): boolean {
  // needsReapproval must be explicitly false: an undefined field (stale
  // payload, renamed key) must never read as "ready to start", since the
  // badge invites the mechanic to begin work at the approved amount.
  return (
    job?.stage === 'quote' &&
    job?.computed?.approvalStatus === 'approved' &&
    job?.computed?.needsReapproval === false
  )
}

export function ApprovedReadyBadge({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center gap-1 rounded-full bg-green-700 px-2.5 py-1 text-xs font-bold uppercase text-white dark:bg-green-500 dark:text-green-950',
        className
      )}
    >
      <CheckCircle2 size={14} />
      Approved — ready to start
    </span>
  )
}
